import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["roof-repair"];

export const Route = createFileRoute("/services/roof-repair")({
  head: () => ({
    meta: [
      { title: "Roof Repair Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Local Southern California roof repair for leaks, cracked tile, lifted shingles and failing flashing. Free estimates from a licensed local crew." },
      { property: "og:title", content: "Roof Repair Southern California – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/roof-repair" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});